<div class="map-section">
  <!-- Main Loading Overlay -->
  @if (isLoading) {
    <div class="main-loader-overlay">
      <div class="loader-container">
        <div class="spinner"></div>
        <p class="loading-text">Loading Dashboard Maps...</p>
      </div>
    </div>
  }

  <!-- Service Down Message -->
  @if (!isLoading && isServiceDown) {
    <div class="service-down-container">
      <div class="service-down-content">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          class="service-down-icon"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
          />
        </svg>
        <h3 class="service-down-title">Service Down</h3>
        <p class="service-down-message">
          <strong>Location Intelligence Toolkit</strong>
        </p>
        <p class="service-down-message">
          The ACCDH Team apologizes for this inconvenience, and will let you
          know when service is restored. Thank you.
        </p>
      </div>
    </div>
  }

  <!-- No Dashboards Message -->
  @if (!isLoading && !isServiceDown && dashboardMaps.length === 0) {
    <div class="no-dashboards-container">
      <div class="no-dashboards-content">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          class="no-dashboards-icon"
        >
          <path
            d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM10 5.47l4 1.4v11.66l-4-1.4V5.47zm-5 .99l3-1.01v11.7l-3 1.16V6.46zm14 11.08l-3 1.01V6.86l3-1.16v11.84z"
          />
        </svg>
        <p>You don't have access to any dashboard maps at the moment.</p>
        <p class="sub-text">
          Please contact your administrator if you believe this is an error.
        </p>
      </div>
    </div>
  } @else if (!isServiceDown) {
    <div class="map-header" id="tour-arcgis-tabs">
      <div class="map-left-section">
        <div class="tabs">
          @for (map of dashboardMaps; track map.id) {
            <button
              type="button"
              class="tab-button"
              [class.active]="selectedMap === map.id"
              (click)="onMapSelect(map)"
            >
              <span class="tab-title">{{ map.title }}</span>
            </button>
          }
        </div>
      </div>
    </div>
    <div class="dashboard-container">
      @if (selectedMap === "4cc725b60d2944ffbe35d2464bee150e") {
        <app-site-toolkit
          [arcgisToken]="arcgisAuthInfo ? arcgisAuthInfo.access_token : ''"
          [toolkitTitle]="'Site Toolkit'"
        ></app-site-toolkit>
      } @else {
        <div class="iframe-container">
          <div class="iframe-tools">
            <div class="tools-wrapper">
              @if (selectedIframeDashboardUrl) {
                <button
                  type="button"
                  class="tool-button"
                  title="Refresh"
                  (click)="refreshIframe()"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                      d="M463.5 224l8.5 0c13.3 0 24-10.7 24-24l0-128c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l119.5 0z"
                    />
                  </svg>
                  <span class="tool-label">Refresh</span>
                </button>
                <button
                  type="button"
                  class="tool-button"
                  title="Expand"
                  (click)="toggleFullscreen()"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                      d="M200 32L56 32C42.7 32 32 42.7 32 56l0 144c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312l0 144c0 13.3 10.7 24 24 24l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8l144 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2l0-144c0-13.3-10.7-24-24-24L312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"
                    />
                  </svg>
                  <span class="tool-label">Fullscreen</span>
                </button>
              } @else {
                <div class="no-tools-message">
                  <span>Select a map to view toolbar options</span>
                </div>
              }
            </div>
          </div>

          <div class="iframe-holder" id="tour-gbra-map">
            <!-- Iframe Loading Overlay -->
            @if (isIframeLoading) {
              <div class="iframe-loader-overlay">
                <div class="iframe-loader-container">
                  <div class="spinner small"></div>
                  <p class="loading-text">Loading Map...</p>
                </div>
              </div>
            }

            @if (selectedIframeDashboardUrl) {
              <iframe
                #iframeElement
                class="dashboard-map-iframe"
                [src]="selectedIframeDashboardUrl | safeUrl"
                (load)="onIframeLoad()"
                (error)="onIframeError()"
              ></iframe>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
